import { useState } from 'react';
export const useScrollState = ()=>{
    const [scrolled, setScrolled] = useState(false);
    const onScroll = (e)=>setScrolled(e.currentTarget.scrollTop > 0);
    return {
        scrolled,
        onScroll
    };
};
